import { CHANGE_REQUEST_TAB, CHANGE_REQUEST_TABS } from './constants';

function emptyTabState() {
  return CHANGE_REQUEST_TABS.reduce((acc, tabId) => {
    acc[tabId] = {
      sections: {},
    };
    return acc;
  }, {});
}

export const portfolioManagerInitialState = {
  panelDataFetchedAt: null,
  panelPendingSnapshot: null,
  entityType: null,
  entityId: null,
  entityName: null,
  entityTitle: null,
  entityStatus: null,
  canApprove: false,
  activeTabId: CHANGE_REQUEST_TAB.MAIN_INFORMATION,
  summary: {
    pendingCount: 0,
    byTab: [],
  },
  tabs: [],
  panelDataReady: false,
  /** Full-page UX (skeleton) while waiting POST + optional redirect to Django ficha */
  changeRequestsReviewNavigateLoading: false,
  categoriesByTab: emptyTabState(),
};

export function getEmptyTabBuckets() {
  return emptyTabState();
}
